import { useEffect, useMemo, useState } from 'react';
import { subscribeTimelineEntriesSnapshot } from '../../../../services/timeline';
import { buildTimelineDaySnapshot } from '../../../Timeline/utils/timelineDaySnapshot';
import { buildContextItems } from './incidentContextBuilder';

export const useIncidentTimelineContext = (childId, incidentTime) => {
  const [timelineEntries, setTimelineEntries] = useState([]);

  useEffect(() => {
    if (!childId) {
      setTimelineEntries([]);
      return undefined;
    }

    const unsubscribe = subscribeTimelineEntriesSnapshot(childId, (entries) => {
      setTimelineEntries(entries || []);
    });

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [childId]);

  const contextItems = useMemo(
    () => buildContextItems(timelineEntries, incidentTime),
    [timelineEntries, incidentTime]
  );

  const todaySnapshot = useMemo(
    () => buildTimelineDaySnapshot(timelineEntries),
    [timelineEntries]
  );

  const patternInsight = useMemo(() => {
    if (todaySnapshot?.text) {
      return todaySnapshot.text;
    }

    return 'Not enough data yet — log a few more events and patterns will show here.';
  }, [todaySnapshot]);

  return {
    timelineEntries,
    contextItems,
    todayInsight: todaySnapshot,
    patternInsight,
  };
};
